import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/siteData";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(
    "Namaste, I'd like to enquire about Sri Bhavani Kalyana Mandira."
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed z-40 bottom-20 right-5 md:right-8 inline-flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl transition-all ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <span className="relative inline-flex">
        <MessageCircle size={20} fill="white" strokeWidth={1.2} />
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-secondary border-2 border-white" />
      </span>
      <span className="font-ui text-sm font-semibold hidden sm:inline">WhatsApp Us</span>
    </a>
  );
}
